import { c as _c } from "react/compiler-runtime";
import { PriceCalendarSkeleton } from "@website/accommodation-ui/price-calendar-wrapper/isLoading";
import { PriceCalendar } from "@website/accommodation-ui/price-calendar-wrapper/price-calendar";
import { useQueryPriceCalendar } from "@website/accommodation-ui/price-calendar-wrapper/queries";
import { PriceCalendarWrapperProperties } from "@website/accommodation-ui/price-calendar-wrapper/types";
import { FC } from "react";
export const PriceCalendarWrapper: FC<PriceCalendarWrapperProperties> = properties => {
  const $ = _c(10);
  const {
    stDate,
    rtDate,
    origin,
    dest,
    passengers
  } = properties;
  let t0;
  if ($[0] !== dest || $[1] !== origin || $[2] !== passengers || $[3] !== rtDate || $[4] !== stDate) {
    t0 = {
      stDate,
      rtDate,
      origin,
      dest,
      passengers
    };
    $[0] = dest;
    $[1] = origin;
    $[2] = passengers;
    $[3] = rtDate;
    $[4] = stDate;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const {
    data: list,
    isFetching,
    isError
  } = useQueryPriceCalendar(t0);
  if (isFetching) {
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PriceCalendarSkeleton />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  if (isError) {
    return null;
  }
  let t1;
  if ($[7] !== list || $[8] !== properties) {
    t1 = <PriceCalendar list={list} {...properties} />;
    $[7] = list;
    $[8] = properties;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};